export const getUserRole = (roles: string[]) =>
  roles.filter((role) => role.includes("tak_user"));
